import { useTranslation } from "react-i18next";
import { Button } from "@/shared/components/ui/button";
import { Building2, LogOut } from "lucide-react";
import { useAuth } from "@/features/Auth/state/AuthContext";

const NoOrganizationScreen = () => {
  const { t } = useTranslation();
  const { user, signOut } = useAuth();

  const displayName = user?.fullName || user?.user_metadata?.full_name || "";

  return (
    <>
      {/* Navbar (modo restricted) é renderizada pelo guard no AppRoutes */}
      <div className="flex h-screen w-full flex-col items-center justify-center gap-6 pt-16 text-center">
        <div className="flex flex-col items-center gap-2">
          <Building2 className="h-16 w-16 text-muted-foreground" />
          <h1 className="text-4xl font-bold tracking-tight">
            {t("auth.noOrganization.title", "Sem organização")}
          </h1>
          <p className="text-lg text-muted-foreground max-w-md">
            {t(
              "auth.noOrganization.description",
              "Você não faz parte de nenhuma organização. Entre em contato com um administrador para receber um convite."
            )}
          </p>
          {user?.email && (
            <p className="text-sm text-muted-foreground">
              {t("auth.noOrganization.signedInAs", "Conectado como")}{" "}
              <span className="font-medium text-foreground">
                {displayName ? `${displayName} (${user.email})` : user.email}
              </span>
            </p>
          )}
        </div>

        <Button variant="default" onClick={() => signOut()}>
          <LogOut className="mr-2 h-4 w-4" />
          {t("auth.signOut", "Sair")}
        </Button>
      </div>
    </>
  );
};

export default NoOrganizationScreen;
